import { Injectable, inject } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserService } from "@kortobaa-front/authentication";

/**
 * Attaches `Authorization: Bearer <token>` to every outbound request,
 * unless the request already carries one (per-call overrides win) or the
 * URL is a known public endpoint that must run unauthenticated.
 *
 * Prevents the post-login 401 cascade that happened when services like
 * TenantContextService fetched /api/me/memberships without the token,
 * triggering GlobalErrorHandler to wipe storage and redirect to /login.
 */
const PUBLIC_URL_PATTERNS: RegExp[] = [
  /\/api\/public\//,
  /\/admin\/login(\/|$)/,
  /\/users\/otp-verify(\/|$)/,
  /\/users\/login(\/|$)/,
  /\/verification-settings(\/|$)/,
  /\/auth\/refresh-token(\/|$)/,
  /\/i18n\//,
  /\/assets\//,
];

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private readonly user = inject(UserService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.has("Authorization")) return next.handle(req);
    if (PUBLIC_URL_PATTERNS.some((re) => re.test(req.url))) return next.handle(req);
    const token = this.user.getToken();
    if (!token) return next.handle(req);
    return next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
  }
}
